import './index.scss'
import React from 'react'

const EmptyPlaceholder = ({ text }) => {
  return (
    <div className="empty" >
      <div className="img"></div>
      <div>
        <span>{text}</span>
      </div>
    </div>
  )
}

export default EmptyPlaceholder
